import { render, staticRenderFns } from "./SupportsList.vue?vue&type=template&id=0fb11ece&scoped=true&"
import script from "./SupportsList.vue?vue&type=script&lang=js&"
export * from "./SupportsList.vue?vue&type=script&lang=js&"
import style0 from "./SupportsList.vue?vue&type=style&index=0&id=0fb11ece&lang=scss&scoped=true&"
import style1 from "./SupportsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb11ece",
  null
  
)

export default component.exports